export const CustomPopover = {
	popoverBackground: 'var(--epods--popover-background)',
	popoverText: 'var(--epods--popover-text)',
	popoverPadding: 'var(--epods--popover-padding)',
	popoverFontSize: 'var(--epods--popover-fontSize)',
	popoverLineHeight: 'var(--epods--popover-lineHeight)',
	popoverDSComponentMarginTop: 'var(--epods--popover-dsComponentMarginTop)',
};
